import { atom, computed } from 'nanostores';
import type { AuthUser } from '@shared/types/auth';

export const $accessToken = atom<string | null>(null);
export const $currentUser = atom<AuthUser | null>(null);
export const $authLoading = atom<boolean>(true);

export const $isAuthenticated = computed([$accessToken, $currentUser], (token, user) => {
  return !!token && !!user;
});

// Track when auth was last set to prevent race-condition clearAuth()
let _lastAuthSetAt = 0;

export function setAuth(accessToken: string, user: AuthUser) {
  $accessToken.set(accessToken);
  $currentUser.set(user);
  _lastAuthSetAt = Date.now();
}

export function clearAuth() {
  /*
   * Don't nuke a freshly-set session — protects against 401 races
   * that fire before the token propagates to all components
   */
  if (Date.now() - _lastAuthSetAt < 3000) {
    console.warn('[Auth] Ignoring clearAuth — session was just set (<3s ago)');
    return;
  }

  $accessToken.set(null);
  $currentUser.set(null);
}

export function setAuthLoading(loading: boolean) {
  $authLoading.set(loading);
}
